export default __webpack_public_path__ + "3271d21b23f6031d06cf5595ff056c28.png";